import { render, staticRenderFns } from "./allOrders.vue?vue&type=template&id=d6afa7e2&scoped=true"
import script from "./allOrders.vue?vue&type=script&lang=js"
export * from "./allOrders.vue?vue&type=script&lang=js"
import style0 from "./allOrders.vue?vue&type=style&index=0&id=d6afa7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6afa7e2",
  null
  
)

export default component.exports